import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Table,
  Tag,
  Card,
  Image,
  Radio,
  Switch,
  message,
  Row,
  Col,
  InputNumber,
} from "antd";

import {
  DeleteOutlined,
  EditOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import Swal from "sweetalert2";
import moment from "moment";
import slugify from "slugify";
import pageApi from "../../api/pageApi";
import menuApi from "../../api/menuApi";

const objectForm = {
  page: null,
  title: null,
  link: null,
  active: false,
  order: 0,
  type: "footer",
  linkType: null,
};

const Category = (props) => {
  const [form] = Form.useForm();
  const { Option } = Select;
  const { TextArea } = Input;

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [valueForm, setValueForm] = useState(objectForm);
  const [isEditModal, setIsEditModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [isModalEditVisible, setIsModalEditVisible] = useState(false);
  const [inputFilter, setFilter] = useState({
    type: "footer",
    sortBy: "createdAt:desc",
    page: 1,
    limit: 10,
  });
  const [menus, setMenus] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [listDeleted, setListDeleted] = useState([]);
  const [type, setType] = useState(1);
  const [isShowLink, setIsShowLink] = useState(false);

  const [pages, setPages] = useState([]);

  useEffect(() => {
    form.setFieldsValue(valueForm);
  }, [form, valueForm, isEditModal]);

  useEffect(() => {
    getMenus();
  }, [inputFilter]);

  const getMenus = () => {
    setLoading(true);
    menuApi
      .getMenus(inputFilter)
      .then((res) => {
        if (res?.results) {
          const data = res?.results.filter((item) => item.linkType === 0);
          setMenus(data);
          setTotalCount(data.length);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const columns = [
    {
      title: "STT",
      render: (id, record, index) => {
        ++index;
        return index;
      },
      className: "text-center",
      width: "5%",
    },
    {
      title: "Tiêu đề",
      dataIndex: "title",
      render: (text) => <h3>{text}</h3>,
      width: "15%",
    },
    {
      title: "Thứ tự hiển thị",
      dataIndex: "order",
      className: "text-center",
      width: 50,
    },
    {
      title: "Trạng thái",
      dataIndex: "active",
      render: (active) => (
        <>
          {active && (
            <Tag color="green" key={active}>
              Hoạt động
            </Tag>
          )}
          {!active && (
            <Tag color="red" key={active}>
              Không hoạt động
            </Tag>
          )}
        </>
      ),
      width: 50,
      className: "text-center",
    },
    {
      title: "Hành động",
      key: "action",
      render: (_, record, index) => (
        <Space size="middle">
          <Button
            onClick={() => showEditModal(record, index)}
            value="large"
            icon={<EditOutlined />}
          >
            Sửa
          </Button>
          <Button
            value="large"
            type="primary"
            icon={<DeleteOutlined />}
            danger
            onClick={() => deleteMenu(record)}
          >
            Xóa
          </Button>
        </Space>
      ),
      width: 150,
      className: "text-center",
    },
  ];

  function onChange(pagination, filters, sorter, extra) {
    setPageSize(pagination.pageSize);
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }
    let sort = "createdAt:desc";
    if (sorter && sorter.columnKey) {
      let order = "ASC";
      if (sorter.order === "descend") {
        order = "DESC";
      }
      sort = sorter.columnKey + " " + order;
    }
    setFilter({
      sortBy: sort,
      limit: pagination.pageSize,
      page: pagination.current,
    });
  }

  const showCreateModal = () => {
    setTitleModal("Thêm chuyên mục");
    setIsEditModal(false);
    setValueForm(objectForm);
    setIsModalEditVisible(true);
  };

  const showEditModal = (record) => {
    setIsEditModal(true);
    setTitleModal("Sửa chuyên mục");
    setValueForm({
      id: record.id,
      title: record.title,
      active: record.active,
      order: record.order,
      type: "footer",
    });
    setIsModalEditVisible(true);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const closePopup = useCallback(() => {
    setValueForm(objectForm);
    setType(1);
    form.resetFields();
    setIsModalEditVisible(false);
  }, [form]);

  const onFinish = useCallback(
    (values) => {
      if (isEditModal) {
        updateHeader(values);
      } else {
        createHeader(values);
      }
    },
    [isEditModal, type]
  );

  const createHeader = (payload) => {
    setLoading(true);
    const item = {
      page: null,
      parent: null,
      title: payload.title,
      link: null,
      active: payload.active,
      order: payload.order,
      type: "footer",
    };
    console.log(item);
    menuApi
      .createMenu(item)
      .then((res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Thao tác thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });

          setIsModalEditVisible(false);
          setLoading(false);
          getMenus();
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const updateHeader = (payload) => {
    setLoading(true);
    const item = {
      title: payload.title,
      active: payload.active,
      order: payload.order,
      type: "footer",
    };
    console.log(item);
    menuApi
      .updateMenu(payload.id, item)
      .then((res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Thao tác thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });

          setIsModalEditVisible(false);
          setLoading(false);
          getMenus();
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const confirm = Modal.confirm;

  const deleteMenu = (record) => {
    const data = {
      ids: [record.id],
    };
    confirm({
      title: "Bạn có muốn xóa mục này không?",
      onOk() {
        menuApi
          .deleteMenu(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công");
              getMenus();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  return (
    <>
      <div className="tabled">
        <Space size={10}>
          <Button
            type="dashed"
            size="small"
            onClick={() => showCreateModal()}
            disabled={menus.length >= 2}
          >
            <EditOutlined /> &nbsp; Thêm chuyên mục
          </Button>
        </Space>
        <br />
        <br />
        <Card
          bordered={true}
          className="criclebox tablespace mt-10 mb-24"
          //   title="Quản lý user hệ thống"
        >
          <div className="table-responsive">
            <Table
              // rowSelection={{
              //   ...rowSelection,
              // }}
              rowKey={(record) => record.id.toString()}
              loading={loading}
              onChange={onChange}
              columns={columns}
              dataSource={menus}
              bordered
              className="ant-border-space"
              pagination={{
                pageSize: pageSize,
                total: totalCount,
                pageSizeOptions: ["10", "50", "100", "200"],
              }}
            />
          </div>
        </Card>
      </div>

      <Modal
        title={titleModal}
        visible={isModalEditVisible}
        onOk={form.submit}
        onCancel={() => {
          closePopup();
        }}
      >
        <div>
          <Form
            initialValues={valueForm}
            form={form}
            name="basic"
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item hidden={true} label="Id" name="id">
              <Input />
            </Form.Item>

            <Form.Item
              label="Tiêu đề"
              name="title"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập tiêu đề!",
                },
              ]}
            >
              <Input placeholder="Nhập tiêu đề..." />
            </Form.Item>
            <Row gutter>
              <Col>
                <Form.Item
                  label="Thứ tự hiển thị"
                  name="order"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng nhập!",
                    },
                  ]}
                >
                  <InputNumber min={0} />
                </Form.Item>
              </Col>
              <Col offset={1}>
                <Form.Item
                  label="Trạng thái"
                  valuePropName="checked"
                  name="active"
                >
                  <Switch />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default Category;
